import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { AmbigousScanResponse, GenericScanResp } from '@core/interfaces/scan-response.interface';
import { SearchOrder } from '@general-data/store/actions/data.actions';
import { Store } from '@ngrx/store';
import { AmbiguousDialogComponent } from '@shared/dialogs/ambiguous-dialog/ambiguous-dialog.component';
import { WTDDialogComponent } from '@shared/dialogs/wtd-dialog/wtd-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class WhatToDoService {
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);

  private panelClasses = ['full-screen-modal'];
  private whatToDoDialog: MatDialogRef<WTDDialogComponent> | undefined = undefined;
  private ambiguousDialog: MatDialogRef<AmbiguousDialogComponent> | undefined = undefined;

  // get dialog instance
  get dialogInstance(): MatDialogRef<WTDDialogComponent> | undefined {
    return this.whatToDoDialog;
  }

  constructor() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.whatToDoDialog?.close();
      }
    });
  }

  public openWTDDialog(scanResponse: GenericScanResp): void {
    if (this.whatToDoDialog && this.whatToDoDialog.componentInstance) {
      // this.whatToDoDialog.close();
      this.whatToDoDialog.componentInstance.data = scanResponse;
    } else {
      this.whatToDoDialog = this.dialog.open(WTDDialogComponent, {
        width: '640px', // '480px',
        height: '100%',
        position: { top: '0px', right: '0px' },
        data: scanResponse,
        disableClose: true,
        panelClass: this.panelClasses,
        hasBackdrop: false,
        autoFocus: '__non_existing_element__',
        restoreFocus: true,
      });
    }
  }

  public closeWTDDialog(): void {
    this.whatToDoDialog?.close();
  }

  public openAmbiguousDialog(scanResponse: AmbigousScanResponse): void {
    if (this.ambiguousDialog && this.ambiguousDialog.componentInstance) {
      this.ambiguousDialog.componentInstance.data = { ...scanResponse };
    } else {
      this.ambiguousDialog = this.dialog.open(AmbiguousDialogComponent, {
        width: '480px',
        height: '100%',
        position: { top: '0px', right: '0px' },
        data: scanResponse,
        disableClose: true,
        panelClass: this.panelClasses,
        hasBackdrop: false,
        autoFocus: true,
        restoreFocus: true,
      });
    }
    this.ambiguousDialog.afterClosed().subscribe((trackingNumber) => {
      if (trackingNumber) {
        this.store.dispatch(SearchOrder({ trackingNumber, ambiguousSelected: true }));
      }
      this.ambiguousDialog = undefined;
    });
  }
}
